import React from 'react';
import { BounceInDownButton } from '../../animation/bounceIn';

const PagenotFound = () => {

    return (

        <div className='LoginRegBg '>
            <div className='crPg-bg-color crPg-bg-image'>
                <section className='d-flex justify-content-center align-items-center min-vh-100'>
                    <BounceInDownButton>
                        <img src={require('../../assets/images/pagenotfound.png')} alt='ipblock' />
                    </BounceInDownButton>
                </section>
            </div>
        </div>

    )
}
export default PagenotFound;